import { apiClient } from './api';
import type { Tenant, CreateTenantRequest, UpdateTenantRequest } from '../types/tenant';

export const tenantService = {
  getAll: async (): Promise<Tenant[]> => {
    const response = await apiClient.get<Tenant[]>('/tenants');
    return response.data;
  },

  getById: async (id: string): Promise<Tenant> => {
    const response = await apiClient.get<Tenant>(`/tenants/${id}`);
    return response.data;
  },

  create: async (data: CreateTenantRequest): Promise<string> => {
    const response = await apiClient.post<string>('/tenants', data);
    return response.data;
  },

  update: async (data: UpdateTenantRequest): Promise<void> => {
    await apiClient.put(`/tenants/${data.id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/tenants/${id}`);
  },
};
